import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import { useConfigContext } from '../../../ui-config'
import { HistoryNode } from '../../common/interface'
import { DataHistoryOrder } from './model'

export function useOrderHistory(): FetchResult<
  HistoryNode<DataHistoryOrder>[]
> {
  const { pollingConfig } = useConfigContext()
  const { data, isLoading, error, mutate } = useSWR<
    FetchResponse<HistoryNode<DataHistoryOrder>[]>,
    FetchError
  >(`/history/orders`, fetchJson<HistoryNode<DataHistoryOrder>[]>, {
    refreshInterval: pollingConfig.intervalInSeconds * 1000,
  })

  return {
    data: data?.body,
    isLoading: isLoading,
    error: error,
    mutate: mutate,
    etag: data?.etag,
  }
}
